import { ApiProperty } from '@nestjs/swagger';
import { IsArray, IsOptional, IsString, IsUUID, MaxLength } from 'class-validator';

export class UpsertPerfilDto {
  @ApiProperty({ example: 'Vendedor Senior', maxLength: 50 })
  @IsString()
  @MaxLength(50)
  perfil!: string;

  @ApiProperty({ required: false, maxLength: 100 })
  @IsOptional()
  @IsString()
  @MaxLength(100)
  desc_perfil?: string;

  @ApiProperty({
    type: [String],
    description: 'IDs de privilegios a asignar al perfil',
    example: ['uuid-1', 'uuid-2'],
  })
  @IsArray()
  @IsUUID('4', { each: true })
  privilegio_ids!: string[];
}
